import "./Process.module.css";
import Header from "@/reusable_sections/Header";
import ProcessPhilosophy from "./sections/ProcessPhilosophy";
import RenovationProcess from "./sections/RenovationProcess";
import RequestEstimate from "./sections/RequestEstimate";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function ProcessPage() {
  return <div>
      <Header />
      <ProcessPhilosophy />
      <RenovationProcess />
      <EstimateRequestForm />
      <RequestEstimate />
      <Footer />
    </div>;
}